export const DirectOrderLabelTextHelper = {
    getLabelText: {
        directOrderNumber: 'Direct Order Number',
        trackingNumber: 'Tracking Number',
        directOrderStatus: 'Direct Order Status',
        directOrderName: 'Name',
        directOrderPhone: 'Phone',
        directOrderEmail: 'Email',
        directOrderAddress1: 'Address 1',
        directOrderAddress2: 'Address 2',
        directOrderAddress3: 'Address 3',
        directOrderPostalcode: 'Postal Code',
        directOrderCity: 'City',
        directOrderState: 'State',
        directOrderCountry: 'Country',
        directOrderCourierCode: 'Last Mile',
        carrierReference: 'Last Mile Reference',
        remarks: 'Remarks',
        customerReference: 'Customer Reference',
        dateCreateOn: 'Create date',
        dateModifyOn: 'Modify date',
        dateCreateOnFrom: 'Create Date From',
        dateCreateOnTo: 'Create Date To',
        action: 'Action'
    }
};
